import gql from 'graphql-tag'

export const ContactContributionPledgeFieldsFragment = gql`
    fragment ContactContributionPledgeFields on ContributionPledge {
        id
        date
        amount
        is_dismissed
        user {
            first_name
            last_name
        }
        note {
            note
        }
    }
`

export const contactContributionPledgesQuery = gql`
    ${ContactContributionPledgeFieldsFragment}
    query ($id: Int!) {
        contactContributionPledges (id: $id) {
            ...ContactContributionPledgeFields
        }
    }
`

export const addContributionPledgeMutation = gql`
    ${ContactContributionPledgeFieldsFragment}
    mutation ($contactId: Int!, $input: ContributionPledgeInput!, $note: String) {
        addContributionPledge(contactId: $contactId, input: $input, note: $note) {
            ...ContactContributionPledgeFields
        }
    }
`

export const dismissContributionPledgeMutation = gql`
    mutation ($id: Int!, $undismiss: Boolean) {
        dismissContributionPledge(id: $id, undismiss: $undismiss) {
            id
            is_dismissed
        }
    }
`

export const deleteContributionPledgeMutation = gql`
    mutation ($id: Int!) {
        deleteContributionPledge(id: $id)
    }
`
